import React from 'react';

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children?: React.ReactNode;
  className?: string;
};

export function Button({ variant = 'primary', size = 'md', className = '', children, ...props }: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold rounded-sm transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-csai-primary';
  
  const variants = {
    primary: 'bg-[var(--color-csai-primary)] text-white hover:bg-[var(--color-csai-primary-hover)] border border-transparent',
    secondary: 'bg-transparent text-[var(--color-csai-primary)] border border-[var(--color-csai-primary)] hover:bg-[var(--color-csai-surface)]',
    ghost: 'bg-transparent text-[var(--color-csai-primary)] border border-transparent hover:bg-black/5',
  };
  
  const sizes = {
    sm: 'h-8 px-3 text-sm',
    md: 'h-10 px-4',
    lg: 'h-12 px-6 text-lg',
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
